export type PageView = '*' | 'text' | 'pdf' | 'latest';

export const PageView = {
  All: '*' as const,
  Text: 'text' as const,
  Pdf: 'pdf' as const,
  Latest: 'latest' as const,
};
